import React from 'react'
import { t } from 'src/translations/src'

const LanguageIcon = ({ size }: { size: number }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    aria-label={t('locale-selector.language-icon-aria-label')}
    strokeWidth='1'
    strokeMiterlimit='10'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path
      d='M4 6.5h8M8 5v1.5m2 0c0 1 0 6-5 6m1-6c0 1 0 6 5 6m2 2.5l3-7 3 7m-5-2h4M2.5 2h19c.6 0 1 .5 1 1.1V17c0 .6-.4 1-1 1H9l-4.3 4c-.1.2-.4.1-.4-.2v-3.9H2.5c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1z'
      stroke='currentColor'
      strokeWidth={1}
      strokeMiterlimit={10}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default LanguageIcon
